module.exports = __webpack_public_path__ + "img/autospin_btn.71043c7b.png";